module.exports = __webpack_public_path__ + "img/shortcode_thumbnail.3b2f53b9.png";